import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class StatusOcorrencia implements Construtor<StatusOcorrencia> {
  public idStatusOcorrencia: number;
  public descricaoStatusOcorrencia: string;
  public pesoStatusOcorrencia: number;
  public tipo: string;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof StatusOcorrencia) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  get obterIdStatusOcorrencia(): number {
    return this.idStatusOcorrencia;
  }

  set IdStatusOcorrencia(idStatusOcorrencia: any) {
    this.idStatusOcorrencia = idStatusOcorrencia;
  }

  get obterDescricaoStatusOcorrencia(): string {
    return this.descricaoStatusOcorrencia;
  }

  set DescricaoStatusOcorrencia(descricaoStatusOcorrencia) {
    this.descricaoStatusOcorrencia = StringValidacao.copiarStringValida(descricaoStatusOcorrencia);
  }

  get obterPesoStatusOcorrencia(): number {
    return this.pesoStatusOcorrencia;
  }

  set PesoStatusOcorrencia(pesoStatusOcorrencia: any) {
    this.pesoStatusOcorrencia = pesoStatusOcorrencia;
  }

  get obterTipo(): string {
    return this.tipo;
  }

  set Tipo(tipo: any) {
    this.tipo = tipo;
  }

  copyObject(statusOcorrencia: StatusOcorrencia): void {
    this.idStatusOcorrencia = statusOcorrencia.obterIdStatusOcorrencia;
    this.descricaoStatusOcorrencia = statusOcorrencia.obterDescricaoStatusOcorrencia;
    this.pesoStatusOcorrencia = statusOcorrencia.obterPesoStatusOcorrencia;
    this.tipo = statusOcorrencia.obterTipo;
  }

  parseFromJson(statusOcorrencia: any): void {
    this.IdStatusOcorrencia = statusOcorrencia.idStatusOcorrencia;
    this.DescricaoStatusOcorrencia = statusOcorrencia.descricaoStatusOcorrencia;
    this.PesoStatusOcorrencia = statusOcorrencia.pesoStatusOcorrencia;
    this.Tipo = statusOcorrencia.tipo;
  }

  modeloCompleto(): boolean {
    return this.descricaoStatusOcorrencia !== undefined;
  }

  getNewInstance(object?: any): StatusOcorrencia {
    return new StatusOcorrencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/status-ocorrencia.ts